import React, { useState, useEffect } from 'react';
import { ReactFlowProvider } from 'reactflow';
import { Dialog, DialogContent, Button, Box } from '@mui/material';
import ETLMapping from './Mapping';
import PropTypes from 'prop-types';
import { resolveFieldsService } from '../../apis/EntitiesSelection';

const ETLMappingDialog = ({ open, onClose, finalConfigPayload }) => {
  const [resolvedFields, setResolvedFields] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (open && finalConfigPayload?.length > 0) {
      fetchResolvedFields();
    }
  }, [open, finalConfigPayload]);

   const fetchResolvedFields = async () => {
      setLoading(true);
      const payload = {
        label: 'FieldResolution',
        configs: finalConfigPayload,
      };
    
      const fields = await resolveFieldsService(payload);
      setResolvedFields(fields);
      setLoading(false);
    };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md"
      PaperProps={{ style: { width: '95%', maxWidth: '95%', height: '95%' } }}
    >
      <DialogContent style={{ display: 'flex', flexDirection: 'column', height: '95%' }}>
        {loading ? (
          <div>Loading fields...</div>
        ) : (
          <ReactFlowProvider>
            <ETLMapping resolvedFields={Array.isArray(resolvedFields) ? resolvedFields : []} />
          </ReactFlowProvider>
        )}
      </DialogContent>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', padding: '16px', height: '7%' }}>
        <Button variant="contained" color="primary" sx={{ width: '10%', marginTop: 2 }} onClick={onClose}>
          Save
        </Button>
      </Box>
    </Dialog>
  );
};

ETLMappingDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  finalConfigPayload: PropTypes.array,
};

export default ETLMappingDialog;
